import React from 'react'
import { useSelector } from 'react-redux';
import ProductCard from './ProductCard';

export const ProductSuggestions = () => {

    const productList = useSelector((state) => state.productList);
    const { loading, error, products } = productList;
    return (
        <div>
            <h4 className='text-xl font-bold mb-4'>Có thể bạn cũng thích</h4>
            <div className='grid grid-cols-2 md:grid-cols-3 gap-4  lg:grid-cols-5 '>
                {products && products?.map((value, index) => {
                    return <ProductCard product={value} />

                })}
            </div>

        </div>
    )
}
